import React from 'react';
import { motion } from 'framer-motion';
export function FloatingDiscountBadge() {
  return <motion.div initial={{
    scale: 0,
    rotate: -180
  }} animate={{
    scale: 1,
    rotate: 12
  }} transition={{
    type: 'spring',
    stiffness: 260,
    damping: 20,
    delay: 1
  }} className="fixed top-24 right-4 sm:right-8 z-40 w-20 h-20 sm:w-24 sm:h-24 bg-brand-purple text-white rounded-full flex flex-col items-center justify-center shadow-2xl border-4 border-white/20 backdrop-blur-sm cursor-pointer hover:scale-110 transition-transform" data-id="element-49">
      <span className="text-xl sm:text-2xl font-bold leading-none" data-id="element-50">50%</span>
      <span className="text-sm sm:text-base font-bold" data-id="element-51">OFF</span>
    </motion.div>;
}